<template>
    <div>
        <div class="p-4 max-w-2xl ml-auto mr-auto">
            <h2 class="mb-4">Write a review</h2>
            <div class="text-left mb-4">
                <div class="mb-4">
                    <h3 class="text-blue-600 mb-1">Your Stay</h3>
                    <p class="text-wrap">
                        You are leaving a review for your stay at
                        {{
                            property
                                ? "P" +
                                  property.p_aid +
                                  " (" +
                                  property.p_title +
                                  ")"
                                : "P" + form.propertyNumber
                        }}.
                    </p>
                    <p class="capitalize">
                        Location: {{ property.location.gl_typed }}
                    </p>
                </div>
                <div class="max-w-sm mr-auto ml-auto">
                    <img
                        :src="imageUrl(property)"
                        class="w-fit rounded-lg"
                        alt="Image not available"
                    />
                </div>
            </div>
            <form @submit.prevent="writeReview" class="text-left">
                <div class="mb-5">
                    <label class="label block mb-1">Your Name</label>
                    <div class="input-group">
                        <so-input
                            required
                            v-model="review.name"
                            :maxlength="55"
                            type="text"
                            class="form-control input-group-item"
                            placeholder="e.g. Jack Holidaymaker"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Review Title - Short summary of your stay</label
                    >
                    <div class="input-group">
                        <so-input
                            required
                            v-model="review.title"
                            :maxlength="150"
                            type="text"
                            class="form-control input-group-item"
                            placeholder="e.g. A great place to stay"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1">Review Description</label>
                    <div class="input-group">
                        <textarea
                            required
                            v-model="review.description"
                            type="textarea"
                            rows="5"
                            class="form-control input-group-item"
                            placeholder="e.g. We loved everything about our stay at this property"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Communication - Was all communication with you
                        effective and timely?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.communication"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Cleanliness - Was the property clean and tidy?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.cleanliness"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Location - Was the location as described?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.location"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Facilities - Were all facilities (e.g. Internet, Pool,
                        Parking) listed on the advert available and in good
                        working order?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.facilities"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Value for money - Was the property priced
                        accurately?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.value"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb-5">
                    <label class="label block mb-1"
                        >Accuracy of listing - Did the property match the Simply
                        Owners description?</label
                    >
                    <div class="input-group">
                        <so-select
                            required
                            v-model="review.accuracy"
                            class="form-control input-group-item"
                            value-attribute="value"
                            textAttribute="text"
                            :options="options"
                        />
                    </div>
                </div>
                <div class="mb5">
                    <button type="submit" class="btn btn_outlined btn_success">
                        <i class="la la-check-circle mr-2"></i>Submit Review
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import SoInput from "../ui/SoInput.vue";
import SoSelect from "../ui/SoSelect.vue";

export default {
    name: "WriteReviewComponent",
    props: ["form", "property"],
    components: { SoSelect, SoInput },
    methods: {
        writeReview() {
            this.$emit("loading", true);
            axios
                .post("/leave-review/submit-review", {
                    form: this.form,
                    review: this.review
                })
                .then(response => {
                    if (response.data.success) {
                        this.successSweetAlert(
                            response,
                            "success",
                            response.data.message
                        );
                        this.$emit("stepChange", 4);
                    } else {
                        this.$swal({
                            icon: "error",
                            title: "Error!",
                            text: response.data.message
                        });
                    }
                    this.$emit("loading", false);
                })
                .catch(error => {
                    this.$swal({
                        icon: "error",
                        title: error.status,
                        text: error.response.data.message
                    });
                    this.$emit("loading", false);
                });
        },
        imageUrl(item) {
            return item?.images !== null && item?.images?.[0] !== undefined
                ? this.imageDomain +
                      "/properties/" +
                      item.images[0].pi_p_aid +
                      "/" +
                      item.images[0].pi_p_aid +
                      "_" +
                      item.images[0].pi_aid +
                      "_768x576.jpg"
                : "/images/awaiting_image.png";
        }
    },
    data() {
        return {
            review: {
                name: null,
                title: null,
                description: null,
                communication: 5,
                cleanliness: 5,
                location: 5,
                facilities: 5,
                value: 5,
                accuracy: 5
            },
            options: [
                { value: 1, text: "1 - Awful" },
                { value: 2, text: "2 - Poor" },
                { value: 3, text: "3 - Fair" },
                { value: 4, text: "4 - Good" },
                { value: 5, text: "5 - Excellent" }
            ],
            imageDomain: import.meta.env.VITE_PROPERTY_IMAGE_DOMAIN
        };
    }
};
</script>
